import { Navigate, useNavigate, useParams } from "react-router-dom";
import { sidebardata } from "../configs/sidebar";

export const useWidgetManager = () => {
  const { route } = useParams();
  const navigate = useNavigate();
  const item = sidebardata.find((el) => el.slug === route);
  if (item) {
    return item;
  } else {
    return {};
  }
};
